"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanExpressionsAvailableInQueryBuilder = void 0;
exports.booleanExpressionsAvailableInQueryBuilder = [
    'EQ',
    'NEQ',
    'GT',
    'LT',
    'GTE',
    'LTE',
    'BETWEEN',
    'CONTAINS',
    'STARTS_WITH',
    'ENDS_WITH',
    'IS_HOLIDAY',
    'IS_WORKDAY',
    'IN',
];
